import styled from 'styled-components'

export const SpeakerListContainer = styled.div<{
  $speakerCount: number
}>`
  position: relative;
  max-width: 1584px;
  margin: 0 auto;
  background-color: ${({ theme }) => theme.webMktNewPalette.white};
  padding-bottom: 96px;

  .SpeakerList {
    display: flex;
    justify-content: ${({ $speakerCount }) => ($speakerCount < 3 ? 'center' : 'flex-start')};
    flex-wrap: wrap;
    gap: 24px;

    ${({ theme }) => theme.breakpoints.down('lg')} {
      margin: 0 32px;
    }
    ${({ theme }) => theme.breakpoints.down('sm')} {
      margin: 0 16px;
    }
    @media (max-width: 767px) {
      flex-direction: column;
    }
    .Speaker {
      text-align: center;
      width: calc(33.3333% - 16px);

      ${({ theme }) => theme.breakpoints.down('sm')} {
        width: calc(50% - 16px);
      }

      @media (max-width: 767px) {
        width: 328px;
        margin: 0 auto;
      }

      .Speaker__Headshot {
        margin-bottom: 24px;
        ${({ theme }) => theme.breakpoints.down('md')} {
          margin-bottom: 16px;
        }
        img {
          width: 320px;
          height: 320px;
          border-radius: 50%;
          object-fit: cover;
          object-position: center;

          ${({ theme }) => theme.breakpoints.down('md')} {
            width: 220px;
            height: 220px;
          }
        }
      }

      .Speaker__Detail {
        padding: 0 16px;
        margin: 0 auto;
      }

      .Speaker__Name {
        font-size: 36px;
        font-weight: 600;
        line-height: 44px;
        letter-spacing: -2px;
        margin-bottom: 4px;

        ${({ theme }) => theme.breakpoints.down('md')} {
          font-size: 24px;
          line-height: 28px;
          letter-spacing: -1px;
        }

        ${({ theme }) => theme.breakpoints.down('sm')} {
          font-size: 22px;
        }
      }

      .Speaker__Designation {
        font-size: 20px;
        font-weight: 400;
        line-height: 32px;
        letter-spacing: -0.5px;
        margin-bottom: 4px;
        ${({ theme }) => theme.breakpoints.down('md')} {
          font-size: 18px;
          line-height: 28px;
        }

        ${({ theme }) => theme.breakpoints.down('sm')} {
          line-height: 28px;
        }
      }

      .Speaker__Company {
        font-size: 24px;
        font-weight: 600;
        line-height: 32px;
        letter-spacing: -1px;
        ${({ theme }) => theme.breakpoints.down('md')} {
          font-size: 20px;
          line-height: 24px;
        }
      }

      .Speaker__Bio {
        display: inline-block;
        margin-top: 4px;
        cursor: pointer;
      }
    }
  }
`
